import React, { useEffect, useState } from 'react'
import MasterService from '../MasterService';
import Header from '../../Component/Header';
import Menu from '../../Component/Menu';
import { spin } from '../../Common/NewLoader';
import { createTheme, ThemeProvider, Tooltip } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import moment from 'moment';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import { Link } from 'react-router-dom';
import Footer from '../../Component/Footer';
import CustomToolbar from '../../CommonComponents/CustomToolbar';
import withRouter from '../../withRouter';

const theme = createTheme({
    overrides: {
      MuiTableCell: {
        head: {
          backgroundColor: "#e9ecef !important",
          border: [[1, "solid", "#ece6e6"]],
        },
        body: {
          border: [[1, "solid", "#ece6e6"]],
        },
      },
    },
  });

const Prefix = () => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
  
    useEffect(() => {
      setLoading(true);
      MasterService.getallprefixes().then((response) => {
        setData(response.data);
        setLoading(false);
      });
    }, []);
    const deletePrefix = () =>{

    }
  
    const columns = [
      { name: "prefix", label: "Prefix Type", options: { filter: true, sort: true } },
      { name: "prefix", label: "Default Prefix", options: { filter: true, sort: true } },
      {
        name: "createdAt",
        label: "Date",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (tableMeta) =>
            moment(tableMeta).format("DD-MM-YYYY HH:mm"),
        },
      },
      {
        name: "Action",
        options: {
          filter: false,
          sort: false,
          empty: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (<>
              <span
                as="button"
                data-tip
                data-for="delete"
                className="cursorpointer"
                // className="btn btn-sm deletebutton"
                onClick={() => {
                  if (
                    window.confirm(
                      `Are you sure you wish to delete ?`
                    )
                  )
                    deletePrefix(tableMeta.rowData.find((e) => e));
                }}
              >
                <Tooltip title="Delete">
                  <DeleteTwoToneIcon color="action"/>
                </Tooltip>
              </span>
              </>
            );
          },
        },
      },
    ];
  
    const options = {
      filterType: "checkbox",
      selectableRows: "none",
      customToolbar: () => {
        return (
          <>
              <Link
                as="button"
                className="float-right btn btn-sm m-0 p-0"
                to={{pathname: "/newprefix"}}
              >
                <CustomToolbar />
              </Link>
          </>
        );
      },
    };
  
    return (
      <div>
        <Header />
        <Menu />
        <div className="content-wrapper">
          <div className="card card-info">
            <ol className="breadcrumb float-sm-right">
              <li className="breadcrumb-item text-secondary">
                <Link to="/superadminmasters" className="text-info">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item active">Prefixes</li>
            </ol>
  
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <div className="card-header m-0 p-2">
                      <div className="text-center text-green"></div>
                    </div>
                    <div>
                      {loading === true ? (
                        <div className="text-center">{spin}</div>
                      ) : (

                                  <div className="mb-4">
                                    <ThemeProvider theme={theme}>
                                      <MUIDataTable
                                        className="table-sm px-3"
                                        title={"Prefixes"}
                                        data={data}
                                        columns={columns}
                                        options={options}
                                      />
                                    </ThemeProvider>
                                  </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <Footer />
      </div>
    );
    
}

export default withRouter(Prefix)